module.exports = __webpack_public_path__ + "img/11087924_L.789ad876.png";